export default {
  form: {
    agreement: {
      label:
        'Je reconnais que mon approbation électronique équivaut à la signature de ce document et que ma signature électronique est juridiquement contraignante.',
    },
    signed_by: {
      label: 'Nom',
      placeholder: 'Nom',
    },
    signer_first_name: {
      label: 'Prénom',
      placeholder: 'Prénom',
    },
    signer_last_name: {
      label: 'Nom de famille',
      placeholder: 'Nom de famille',
    },
    recipient_email: {
      label: 'Adresse e-mail du destinataire',
      placeholder: "Saisir l'adresse e-mail",
    },
    send_to_email: {
      label: 'Envoyer le contrat au propriétaire par e-mail ({{email}})',
    },
    additional_locations: {
      label: 'Emplacements supplémentaires',
      placeholder: 'Rechercher un emplacement à ajouter',
    },
    special_agreements: {
      label: 'Accords spéciaux',
      placeholder: 'Saisir les accords spéciaux',
    },
  },
  labels: {
    name: 'Nom',
    date: 'Date',
  },
  buttons: {
    sign_in_person: 'Signer ici avec le propriétaire',
    back: 'Retour',
    edit_contract: 'Modifier le contrat',
    skip: 'Ignorer',
    sign: 'Signer',
    init_sign: 'Créer le contrat et envoyer',
    redo: 'Refaire',
    continue: 'Continuer',
    preview: 'Aperçu',
    submit: 'Soumettre',
  },
  toasts: {
    failed_to_preview_contract: "Impossible d'afficher l'aperçu du contrat",
    contract_signing_pending: 'Veuillez patienter, nous initions votre contrat...',
    failed_to_sign_contract: "Échec de l'initiation du contrat ⁉️",
    contract_got_signed: 'Contrat initié 👌',
  },
  in_person_signing: {
    description:
      'Le propriétaire a reçu ce lien par e-mail et peut signer à distance. Si le propriétaire est avec vous, ouvrez la page de signature ici.',
  },
  signature_link: {
    label: 'Lien de signature (même lien envoyé au destinataire par e-mail)',
    copy: 'Copier',
    copied: 'Lien de signature copié dans le presse-papiers',
  },
  header: 'Créer un contrat',
  description:
    "Veuillez vérifier les détails du contrat et saisir l'adresse e-mail à laquelle le contrat doit être envoyé.",
};
